module.exports = __webpack_public_path__ + "img/error.26749e58.svg";